export function debounce(callback, ms) {
	let timeout = null

	return (...args) => {
		clearTimeout(timeout)

		timeout = setTimeout(() => {
			callback(...args)
		}, ms)
	}
}